import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'signed_copies_contracts_between_facility_each_worker_are'

export const dataPointDefinition = {
  retracedId: 'signed_copies_contracts_between_facility_each_worker_are',
  name: 'Signed copies of contracts between the facility and each worker are not maintained on file',
  description:
    'The intent of this option selection is to understand if signed copies of contracts between the facility and each worker are maintained on file.',
  meta: {
    slcpMeta: {
      key: 'rh-emp-14',
      number: 'RH-EMP-11-1',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'rh-emp-14', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34430,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
